import React from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import {
  INCOMING_MESSAGES_FETCH_SUCCESS,
  INCOMING_MESSAGES_FETCH_ERROR,
  OUTGOING_MESSAGES_FETCH_SUCCESS,
  OUTGOING_MESSAGES_FETCH_ERROR,
} from '../../actions/types';
import CustomText from '../../components/customText/CustomText';
import HomeHeader from '../../components/homeHeader/HomeHeader';
import MessageRadar from '../../components/messageRadar';
import theme from '../../constants/theme.style.js';
import StatsContainer from '../../components/statsContainer/StatsContainer';
import NotificationHandler from '../../components/notifications';
import { baseUrl } from '../../constants/baseUrl';

const letter = require('../../assets/icons/letter.png');
const letterOutgoing = require('../../assets/icons/letter-outgoing.png');
const friendRequest = require('../../assets/icons/friend-plus.png');

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: theme.GREEN_DARKER_COLOR,
  },
  body: {
    flex: 1,
    backgroundColor: theme.WHITE_COLOR,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    padding: 40,
    paddingTop: 20,
  },
  centerWrap: {
    maxWidth: 900,
    width: '100%',
    alignSelf: 'center',
  },
  bodyHeader: {
    fontSize: 20,
    fontWeight: '700',
    marginTop: 30,
    marginBottom: 30,
    color: theme.GREY_DARKER_COLOR,
    fontFamily: 'Nunito_ExtraBold',
  },
  radarContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  fillerView: {
    height: 150,
  },
});

export default class HomeScreen extends React.Component {
  constructor(props) {
    const { incomingMessages, outgoingMessages, currentUser } = props;
    super(props);

    const currentId = currentUser.user ? currentUser.user.id : undefined;
    incomingMessages(
      `${baseUrl}message/notReceivedMessages/${currentId}`,
      INCOMING_MESSAGES_FETCH_SUCCESS,
      INCOMING_MESSAGES_FETCH_ERROR,
    );
    outgoingMessages(
      `${baseUrl}message/notDeliveredMessages/${currentId}`,
      OUTGOING_MESSAGES_FETCH_SUCCESS,
      OUTGOING_MESSAGES_FETCH_ERROR,
    );
  }

  render() {
    const { currentUser, friendRequests, navigation } = this.props;
    if (currentUser.user === undefined) {
      navigation.navigate('Auth');
      return null;
    }
    const firstname = currentUser.user.firstname !== undefined ? currentUser.user.firstname : '';
    const incoming =
      'incomingMessageCount' in currentUser ? currentUser.incomingMessageCount.length : 0;
    const outgoing =
      'outgoingMessageCount' in currentUser ? currentUser.outgoingMessageCount.length : 0;

    return (
      <View style={styles.container}>
        <View style={styles.centerWrap}>
          <HomeHeader firstname={firstname} />
        </View>
        <ScrollView style={styles.body}>
          <View style={styles.centerWrap}>
            <CustomText style={styles.bodyHeader}>Turtlets on their way</CustomText>
            <View style={styles.radarContainer}>
              <MessageRadar />
            </View>
            <StatsContainer
              image={letter}
              headline="Incoming Turtlets"
              subheader="from your friends"
              amount={incoming}
            />
            <StatsContainer
              image={letterOutgoing}
              headline="Outgoing Turtlets"
              subheader="to your friends"
              amount={outgoing}
            />
            <CustomText style={styles.bodyHeader}>Friend requests</CustomText>
            {friendRequests > 0 && (
              <StatsContainer
                navigation={navigation}
                navigateTo="Friends"
                image={friendRequest}
                headline="Some requests"
                subheader="are waiting for your reply"
                amount={friendRequests}
              />
            )}
            {friendRequests <= 0 && (
              <StatsContainer
                image={friendRequest}
                headline="No requests"
                subheader="are currently waiting for your reply"
                amount=""
              />
            )}
            <NotificationHandler />
            <View style={styles.fillerView} />
          </View>
        </ScrollView>
      </View>
    );
  }
}
